export { RegistrationPage as default } from '../../components-v2/auth/AuthPages';
